import { Route, Routes } from 'react-router-dom';
import Layout from '../../components/layout';
import PulseCdnFramePage from './frame/PulseCdnFramePage.tsx';
import PulseCdnPage from './full/PulseCdnPage.tsx';

export default function PulseCdnRouter() {
  return (
    <Routes>
      <Route element={<PulseCdnFramePage />} path="frame/*" />
      <Route
        element={
          <Layout>
            <PulseCdnPage />
          </Layout>
        }
        path="*"
      />
    </Routes>
  );
}
